<template>
  <v-container>
    <UserPasswordFormModal :show="changingPassword" @close="changingPassword = false" />
    <UserEditPictureModal :show="changingPicture" @close="changingPicture = false" />
    <v-row v-if="user.brand">
      <v-col cols="12" lg="6" xl="5">
        <v-card shaped>
          <v-img @mouseenter="showUploader = true" @mouseleave="showUploader = false" :src="picturePath || $store.state.defaultPicture" max-height="200px" contain></v-img>
          <v-card-text>
            <v-list>
              <template v-for="(info, index) in informations">
                <v-list-item :key="'info' + index">
                  <v-list-item-avatar>
                    <v-icon>{{info.icon}}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{info.label}}
                  </v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{info.value}}
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="'divider' + index"></v-divider>
              </template>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="openModal">{{$t('ProfilePage.Button.changePassword')}}</v-btn>
            <v-btn rounded color="primary" dark @click="changingPicture = true">Changer de logo</v-btn>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UserPasswordFormModal from '@/components/User/UserPasswordFormModal'
import UserEditPictureModal from '@/components/User/UserEditPictureModal'
export default {
  name: 'TheProfilePage',
  components: { UserPasswordFormModal, UserEditPictureModal },
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    ...mapGetters('auth', [
      'picturePath'
    ]),
    informations () {
      return [
        {label: 'Enseigne', value: this.user.brand, icon: 'store'},
        {label: 'Centre', value: this.user.mall.name, icon: 'domain'},
        {label: 'Responsable', value: this.user.firstName + ' ' + this.user.lastName, icon: 'account_box'},
        {label: 'Équivalent temps plein', value: this.user.fullTimeEquivalent, icon: 'room'},
        {label: 'Email', value: this.user.email, icon: 'alternate_email'},
        {label: 'Etage', value: this.user.floor, icon: 'room'},
        {label: 'Surface (m2)', value: this.user.area, icon: 'room'},
        {label: 'N° de cellule', value: this.user.unit, icon: 'room'},
        {label: 'Date d\'ouverture', value: (new Date(this.user.openingDate)).toLocaleString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric'}), icon: 'today'},
      ]
    }
  },
  data () {
    return {
      changingPassword: false,
      changingPicture: false,
      showUploader: false
    }
  },
  methods: {
    openModal () {
      this.changingPassword = true
    }
  }
}
</script>

<style scoped>
.syno-avatar {
  border: 3px solid;
  border-radius: 50%;
}
</style>
